/**
 * Scala z-index deliberata per le superfici del Personal Assistant (bubble
 * `FloatingFab` + `WorkspaceShell`/`MobileShell`). Centralizzare i valori qui
 * garantisce che le superfici PA stiano SEMPRE sopra il contenuto di pagina e i
 * popover/dropdown applicativi — inclusa l'outlier `SelectContent` (`z-[9999]`)
 * e i Radix condivisi (`z-50`) — restando nella banda ~10000 dei modali ad-hoc.
 *
 * Assunzione (ribaltabile cambiando i numeri qui): la bubble sta sopra
 * contenuto + popover/dropdown ma sotto i modali applicativi "veri" della banda
 * 10001+. Le superfici PA sono portalate su `document.body`, quindi questi
 * valori competono solo con gli altri stacking-context radice.
 *
 * Sono numeri pensati per `style={{ zIndex }}`: Tailwind JIT non estrae classi
 * arbitrarie dinamiche (`z-[${x}]`), quindi le superfici PA usano lo stile
 * inline invece di una classe `z-[...]`.
 */
export const Z_PA_FAB = 10000;
export const Z_PA_SHELL = 10000;
/** Overlay full-screen interni allo shell mobile (pannello sezione). */
export const Z_PA_SHELL_OVERLAY = 10010;
/** Dropdown switcher modello: sopra shell e overlay sezione. */
export const Z_PA_SHELL_DROPDOWN = 10020;
/** Overlay full-screen mobile più alto (viewer artefatto). */
export const Z_PA_SHELL_OVERLAY_TOP = 10030;
